import { AnyGoalDoc, NewMultiStepGoal } from "@ailenax-overlay/shared";

export const getMultiStepStep = (goal: NewMultiStepGoal) => {
    let progress = goal.progress;
    if (goal.wrapAround) {
      const sumOfSteps = goal.steps.reduce((sum, step) => sum + step.goal, 0);
      progress = goal.progress % sumOfSteps;
    }
  
    console.log({
      goal,
      steps: goal.steps
    });
    return goal.steps.find(s => s.goal > progress) ?? goal.steps[goal.steps.length - 1];
  }
  
  export const getCurrentTitle = (goal: AnyGoalDoc) => {
    if (goal.goalType === "simple") {
      const num = ~~(goal.progress / goal.goal);
      if (num === 0 || !goal.autoReset) {
          return goal.title.replace("[counter]", "").replace(/\s+/, " ");
      }
      return goal.title.replace("[counter]", `(${num.toFixed(0)}x)`);
    }
  
    return getMultiStepStep(goal).title;
  }